import React from "react";
import filterIcon from "../../../../assets/filter.svg";
import Dropdown from "react-bootstrap/Dropdown";
import { v4 } from "uuid";

// Styles
import "./ActivityFilters.scss";

const filterOptions = ["All Comments", "Your Mentions", "File Updates"];
const SEARCH_DELAY = 1500;

const FilterSection = ({ setActivityPage, activityPage, isEmpty, markAllActivitiesAsRead, setActivities }) => {
  const [searchString, setSearchString] = React.useState(null);
  const { filterString } = activityPage;

  React.useEffect(() => {
    setActivities({});
    if (searchString != null) {
      const delaySearch = setTimeout(() => {
        setActivityPage((activityPage) => {
          return {
            ...activityPage,
            searchString: searchString.trim(),
            currPage: 1,
            wasLastList: false,
          };
        });
      }, SEARCH_DELAY);
      return () => clearTimeout(delaySearch);
    }
  }, [searchString, setActivityPage, setActivities]);

  const getFilterBox = React.forwardRef(({ onClick }, ref) => (
    <button
      className={`dropdown custom-dropdown ic-ghost ${filterString !== "" ? `active-filter` : ``}`}
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <img className="dropdown-toggle" src={filterIcon} alt="Filter" />
    </button>
  ));

  const applyFilter = (filterString = "") => {
    setActivities({});
    setActivityPage((activityPage) => {
      return {
        ...activityPage,
        filterString: filterString,
        currPage: 1,
        wasLastList: false,
      };
    });
  };

  return (
    <div className="activity-filter-container">
      {!isEmpty ? (
        <>
          <div className="search-filter-container">
            <div className="search-box mr-2">
              <input
                type="text"
                maxLength="50"
                placeholder="&#xF002;  Search for Activity"
                className="search-placeholder set-width"
                value={searchString ?? ""}
                onChange={(e) => {
                  const str = e.target.value;
                  if (str.trim().length > 0 || str.length === str.trim().length) {
                    setSearchString(e.target.value);
                  }
                }}
              />
            </div>
            <div className="filter">
              <Dropdown>
                <Dropdown.Toggle as={getFilterBox}></Dropdown.Toggle>
                <Dropdown.Menu>
                  {filterOptions.map((filterOption) => (
                    <Dropdown.Item
                      as="a"
                      key={v4()}
                      active={filterOption === filterString}
                      onClick={() => {
                        applyFilter(filterOption);
                      }}
                    >
                      <div>{filterOption}</div>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {filterString !== "" ? (
              <div className="clear-filter" onClick={() => applyFilter()}>
                Clear
              </div>
            ) : null}
          </div>
          <div className="mark-all-as-read" onClick={markAllActivitiesAsRead}>
            Mark All As Read
          </div>
        </>
      ) : null}
    </div>
  );
};

export default FilterSection;
